<template>
  <div>
    <div class="rich-text-wrapper" style="position: relative">
      <i class="mdi mdi-arrow-expand expand" @click="show = true" title="Expand to full screen"></i>
      <div class="rich-text" v-html="value"></div>
    </div>
    <el-dialog :visible.sync="show" :title="title" width="70%" @open="handleOpen" :before-close="handleClose" :modal="true" :append-to-body="true" :destroy-on-close="true">
      <div v-if="!showTinyMce" v-html="value"></div>
      <Tinymce v-if="showTinyMce" id="dialogEdit" :height="250" v-model="value" :containerName="containerName"> </Tinymce>

      <span slot="footer">
        <template v-if="!editable">
          <el-button @click="show = false" size="mini" plain round>Close</el-button>
        </template>
        <el-button-group v-else>
          <el-button key="button1" v-if="!showTinyMce" @click="showTinyMce = true" size="mini" type="text" plain round>Edit</el-button>
          <el-button key="button2" v-if="showTinyMce" @click="handleCancel" type="text" plain round>Cancel</el-button>
          <el-button key="button3" v-if="showTinyMce" @click="handleConfirm" plain round>Confirm</el-button>
          <el-button key="button4" v-if="!showTinyMce" @click="handleClose" size="mini" plain round>Close</el-button>
        </el-button-group>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'
import HiaAuthorization from '@/mixins/hiaAuthorization'

export default {
  name: 'hiaRichText',
  props: ['value', 'title', 'editable', 'containerName'],
  mixins: [HiaAuthorization],
  data() {
    return {
      show: false,
      showTinyMce: false,
      localBackup: null
    }
  },
  components: {
    Tinymce
  },
  mounted: function() {},
  created: function() {},
  methods: {
    handleClose() {
      this.show = false
      this.showTinyMce = false
      this.value = this.localBackup
    },
    handleCancel() {
      this.value = this.localBackup
      this.showTinyMce = false
      this.show = false
    },
    handleConfirm() {
      this.$emit('input', this.value)
      this.$emit('change')
      this.showTinyMce = false
      this.show = false
    },
    handleOpen() {
      this.localBackup = this.value
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>
.rich-text {
  border: 1px solid #dcdfe6;
  background: #fff;
  border-radius: 4px;
  padding: 10px;
  margin: 10px 10px 20px 0px;
  min-height: 30px;
  font-size: 14px;
  overflow-x: auto;
}

.expand {
  position: absolute;
  top: -5px;
  right: 5px;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
  border-radius: 50%;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  opacity: 0.9;
  color: #606266;
  transition: all 0.2s ease;
  z-index: 10;
}

.expand:hover {
  opacity: 1;
  background-color: #f5f7fa;
  color: #409eff;
}
</style>
